export default function updateTokensInLocalStorage(data) {
  if (data?.refreshToken && data?.accessToken) {
    localStorage.setItem('refreshToken', `${data.refreshToken}`);
    localStorage.setItem('accessToken', `${data.accessToken}`);
  }
}
